import { styled } from '../theme';
import Text from './Text';

export default styled(Text)(({ theme }) => theme.typography.textStyles.caption1);
